import type { RouteRecordRaw } from "vue-router";

import { APP_CHAT_PROFESSIONAL_ROUTES } from "@/Generated/Routes/paths";

import { buildBeforeEnterChain, chatCustomerGuard } from "@/Router/guards";

const Professionals: RouteRecordRaw[] = [
  {
    ...APP_CHAT_PROFESSIONAL_ROUTES.root,
    meta: {
      i18nTitle: "chat.settings.professional.header",
      sidebar: true,
    },
    component: () => import("@/Views/chat/professional/index.vue"),
    beforeEnter: buildBeforeEnterChain(chatCustomerGuard),
  },
];

export default Professionals;
